module.exports = __webpack_public_path__ + "static/media/app-icon.6d8be625.png";